const constants = {
	notifications: {
		newImage: [
			'NEW_APPLICATION', 'SCHEDULED_NOTIFICATION', 'NEW_JOB', 'MAKE_A_MANAGER', 'MAKE_NOT_A_MANAGER', 'CONFIRMED_APPLICATION',
			'NEW_TIME_TRACK', 'EDIT_TIME_TRACK', 'COMMENTED_TIME_TRACK_BY_NURSE', 'COMMENTED_TIME_TRACK_BY_MANAGER', 'NEW_MESSAGE',
			'UPLIFT_SUGGESTED_BY_SHIFT_MANAGER', 'UPLIFT_SUGGESTED_BY_BANK_OFFICER', 'UPLIFT_COMMENTED_BY_BANK_OFFICER', 'UPLIFT_COMMENTED_BY_SHIFT_MANAGER', 'UPLIFT_COMMENTED_BY_RATE_MANAGER', 'RATE_INCREASE',
		],
		okImage: [
			'AUTO_APPLY_APPLICATION', 'ACCOUNT_IS_APPROVED', 'OFFERED_APPLICATION', 'FEEDBACK_IS_REQUESTED', 'FEEDBACK_IS_PROVIDED',
			'APPROVED_TIME_TRACK',
			'UPLIFT_APPROVED',
		],
		rejectedImage: [
			'CANCELLED_APPLICATION_BY_NURSE',
			'REJECTED_TIME_TRACK',
			'UPLIFT_REJECTED', 'UPLIFT_CANCELLED',
		],
		yesterday: 'a day ago',
	},
	notificationActions: {
		forApprove: ['NEW_TIME_TRACK', 'EDIT_TIME_TRACK'],
		jobDetails: [
			'OFFERED_APPLICATION', 'NEW_JOB', 'SCHEDULED_NOTIFICATION', 'NEW_APPLICATION', 'REJECTED_APPLICATION_BY_NURSE', 'CONFIRMED_APPLICATION',
			'COMMENTED_TIME_TRACK_BY_NURSE', 'COMMENTED_TIME_TRACK_BY_MANAGER', 'APPROVED_TIME_TRACK', 'REJECTED_TIME_TRACK',
		],
		jobRates: [
			'UPLIFT_SUGGESTED_BY_SHIFT_MANAGER', 'UPLIFT_SUGGESTED_BY_BANK_OFFICER', 'UPLIFT_COMMENTED_BY_BANK_OFFICER', 'UPLIFT_COMMENTED_BY_SHIFT_MANAGER',
			'UPLIFT_COMMENTED_BY_RATE_MANAGER', 'UPLIFT_APPROVED', 'UPLIFT_REJECTED', 'UPLIFT_CANCELLED', 'RATE_INCREASE',
		],
		userDetails: ['MAKE_A_MANAGER', 'ACCOUNT_IS_APPROVED', 'ACCOUNT_IS_DECLINED'],
		messageDetails: ['NEW_MESSAGE']
	},
};

export default constants;
